import React, { useEffect, useState } from "react";
import { DPButton, DPSpacer } from "Components/DP";
import { Box, Dialog, FormLabel, Grid, Typography } from "@material-ui/core";
import pretty from "Shared/pretty";
import { Controller, useForm } from "react-hook-form";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";
import { Option } from "Shared/types/Option";
import { DisbursementReasonCategory } from "generated/graphql";
import { DISBURSEMENTS_OPTIONS } from "Shared/Constants/Constants";
import useStyles from "./styles";

export interface ConfirmationDialogProps {
  file?: File;
  totalCount: number;
  totalAmount: number;
  onConfirm: (reason: DisbursementReasonCategory) => void;
  onClose: () => void;
}

export type DisbursementsReason = {
  reasonName: Option | null;
}

export function ConfirmationDialog({
  file,
  totalCount,
  totalAmount,
  onConfirm,
  onClose,
}: ConfirmationDialogProps) {
  const { control, watch } = useForm<DisbursementsReason>({
    mode: "onBlur",
  });
  const watchReason = watch("reasonName");
  const classes = useStyles({ reason: watchReason?.value as DisbursementReasonCategory});
  const totalAmountCents = Math.round(totalAmount * 100);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleConfirm = () => {
    setIsConfirmed(true);
    onConfirm(watchReason!.value as DisbursementReasonCategory);
  };

  useEffect(() => {
    setIsConfirmed(false);
  }, [file]);

  return (
    <Dialog open={!!file}>
      <Box display="flex" flexDirection="column" padding={3} className={classes.contentWrapper}>
        <Box display="flex" flexDirection="column" alignItems="center" className={classes.topBox}>
          <Typography className={classes.yourFile}>
            Your file:
          </Typography>
          <DPSpacer spacing={2} />
          <Typography>
            {totalCount} payment{totalCount === 1 ? "" : "s"}, {pretty.dollar(totalAmountCents)} total
          </Typography>
          <Typography>
            {file?.name}
          </Typography>
        </Box>

        <FormLabel className={classes.label}>Payment reason:</FormLabel>
        <Controller
          name="reasonName"
          control={control}
          defaultValue={null}
          rules={{ required: true }}
          render={props => (
            <DPReactSelect
              {...props}
              placeholder="Please select"
              options={DISBURSEMENTS_OPTIONS}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          )}
        />
        <DPSpacer spacing={2} />
        <Typography className={classes.terminationNotice}>
          Payments sent for Termination to a DailyPay user's DPA will also cancel their DailyPay account.
        </Typography>
        <DPSpacer spacing={3} />
        <Grid container justify="space-between">
          <DPButton
            variant="text"
            className={classes.cancel}
            onClick={onClose}
          >
            Cancel
          </DPButton>
          <DPButton
            onClick={handleConfirm}
            disabled={!file || !watchReason || isConfirmed}
          >
            Upload this file
          </DPButton>
        </Grid>
      </Box>
    </Dialog>
  );
}
